module.exports = __webpack_public_path__ + "static/Dataguise-d0a9009f277906dd8df4efda02eda885.jpg";